// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5e17eb39","453":"57a50afe","461":"9ef858f2"}[chunkId] + ".chunk.js";
};